const timeline = () => {
	var inputs = $('.timelineDate')
	var paras = $('.timelineDescription').find('p')
	$(inputs).click(function() {
		var t = $(this),
			ind = t.index(),
			matchedPara = $(paras).eq(ind)

		$(t)
			.add(matchedPara)
			.addClass('active')
		$(inputs)
			.not(t)
			.add($(paras).not(matchedPara))
			.removeClass('active')
	})
}
export { timeline }
